import { GoFormzServices } from '../AppSettings';
import { apimCall } from '../helpers/api';
import { AgentRequest, AgentResponse, ConversationHistoryResponse, ConversationSessionDocument, MessageVote } from './goFormz-agent-types';

export async function chatWithAgent(
  templateId: string,
  pageId: string | null,
  selectedDataLayoutId: string | null,
  fieldId: string | null,
  property: string | null,
  propertyValue: string | null,
  query: string,
  conversationSessionId: string | null = null
): Promise<AgentResponse> {
  const body: AgentRequest = {
    templateId,
    pageId,
    selectedDataLayoutId,
    fieldId,
    fieldProperty: property,
    fieldPropertyValue: propertyValue,
    query,
    conversationSessionId: conversationSessionId // Populate this if needed
  };

  const response = await apimCall<AgentResponse>(GoFormzServices.AIService, '/ai/agent', 'POST', body);
  return response.data;
}

export async function voteOnAgentMessage(sessionId: string, messageId: string, vote: MessageVote) {
  const body = {
    conversationSessionId: sessionId,
    messageId,
    vote
  };
  const response = await apimCall<AgentResponse>(GoFormzServices.AIService, '/ai/agent/vote', 'POST', body);
  return response.data;
}

export async function getConversationBySessionId(sessionId: string) {
  const response = await apimCall<ConversationSessionDocument>(GoFormzServices.AIService, `/ai/agent/sessions/${sessionId}`, 'GET');
  return response.data;
}

export async function getConversationHistory() {
  const response = await apimCall<ConversationHistoryResponse>(GoFormzServices.AIService, '/ai/agent/history', 'GET');
  return response.data;
}

export async function deleteConversationBySessionId(sessionId: string) {
  await apimCall<ConversationSessionDocument>(GoFormzServices.AIService, `/ai/agent/sessions/${sessionId}`, 'DELETE');
}
